module.exports = __webpack_public_path__ + "static/media/2019_IMG_2049.20eafab3.jpg";